import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ISelectCompaniesPayload {
    sharedListId: string
    data: {
        selectedCompanies: any
    }
    sagaCB?: any
}

export interface ISelectCompaniesState {
    status: string
    data: any
    errors: any
}

const initialState: ISelectCompaniesState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const selectCompanies = createSlice({
    name: 'sharedList/select-companies',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ISelectCompaniesPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const selectCompaniesActions = selectCompanies.actions
export default selectCompanies.reducer
